import { faSearch, faShoppingBasket, faTag, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Button } from 'reactstrap';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { alerts } from '../../actions/Alerts';
import { getBinDiscounts } from '../../actions/Bindiscounts';
import { updateCart } from '../../actions/Cart';
import {
  clearItems, clearLocation, getLocation,
  getLocationLayoutSettings,
  getOutlets, setLocation
} from '../../actions/Locations';
import { getLoyalties } from '../../actions/Loyalties';
import { getPaymentProcessor } from '../../actions/Payments';
import { getPromotions } from '../../actions/Promotions';

import CONSTANTS from '../../constants';
import OrderTypeHelper from '../../helpers/OrderTypeHelper';
import ParamHelper from '../../helpers/ParamHelper';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import CartService from '../../services/CartService';
import LoginService from '../../services/LoginService';
import QRCodeService from '../../services/QRCodeService';
import UserLocationService from '../../services/UserLocationService';
import MenuCart from '../cart/MenuCart';
import ViewCart from '../cart/ViewCart';
import Categories from '../categories/Categories';

import AnnouncementBar from '../navbar/AnnouncementBar';
import Topheader from '../navbar/Topheader';

import StatusBlock from '../orders/StatusBlock';
import RouteModal from '../outletRoute/RouteModal';
import ErrorHandler from '../shared/ErrorHandler';
import Spinner from '../shared/Spinner';
import Toast from '../shared/Toast';
import withBackButtonHandled from '../shared/WithBackButtonHandled';
import Footer from '../top-menu/Footer';
import AccDeletion from './AccDeletion';
import Banner from './Banner';
import Info from './Info';
import Intro from './Intro';
import PopularItems from './PopularItems';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import debounce from 'lodash.debounce';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';
import { Autoplay, Pagination } from 'swiper';
import Cookies from 'universal-cookie';
import '../../App.scss';
import { getCategories } from '../../actions/Categories';
import { getAllItems } from '../../actions/Items';
import { getNotifications } from '../../actions/Notifications';
import logo from '../../assets/images/logo.png';
import restaurantSettingBg from '../../assets/static/restaurent-setting-bg.svg';
import ImageHelper from '../../helpers/ImageHelper';
import TimeHelper from '../../helpers/TimeHelper';
import FirebaseNotificationService from '../../services/FirebaseNotificationService';
import ItemModal from '../items/ItemModal';
import Items from '../items/Items';
import PrefModal from '../orderPreferences/PrefModal';
import BindiscountItems from '../promotional/bindiscounts-items';
import PromotionalItems from '../promotional/promotional-items';
import CustomLogin from '../sessions/CustomLogin';
import OutletInformation from '../top-menu/outlet-information';
import BinDiscountsModal from './BinDiscountsModal';

const cookies = new Cookies();

class Menu extends Component {
  constructor(props) {
    super(props);
    this.searchInputBoxRef = createRef();
    this.searchInputParentRef = createRef();
    this.checkOutRef = createRef();
    this.searchInputRef = createRef();
    this.videoRef = createRef();
    this.state = {
      isOrderingEnabled: true,
      item_id: '',
      showModal: false,
      showOrderPref: false,
      showRouteModal: false,
      selectedItem: null,
      titles: [],
      geoLocation: null,
      selectedOutlet: null,
      orderData: null,
      isLoaded: false,
      isLoggedIn: false,
      widthSize: window.screen.width,
      searchText: '',
      grid_layout: 'default',
      banner_image_list: [],
      mobile_banner_image_list: [],
      banner_details: [],
      searchInputVisibility: false,
      searchbar_open_close_classname: '',
      searchBarOpened: false,
      showOrderPrefMobile: false,
      refreshItem: false,
      active: false,
      isMasterOpen: true,
      showLoginModal: false,
      isLocationEnable: false,
      showAccModal: false,
      showBinModal: false,
    };
    UserLocationService.setCheckForLocation(false);
    // this.timeoutId = null;
  }

  changeLayout(type) {
    localStorage.setItem('grid_layout', `${type}`);
    this.setState({
      ...this.state,
      grid_layout: type
    });
  }

  categoryChangeEvent() {
    if (!this.props.toast) this.props.getToastSettings(1);
  }

  onGeoLocationSuccess(position) {
    let geoLocation = `${position.coords.latitude},${position.coords.longitude}`;
    this.setState({ geoLocation });
  }

  onGeoLocationError() {
    UserLocationService.setCheckForLocation(true);
    //alert('Plugd needs your device location for delivery orders. Please enable your GPS.');
  }

  firebaseEvent(eventName) {
    AnalyticsService.logEvent(eventName, {
      event: eventName
    });
    if (this.props._location) {
      AnalyticsService.logRestaurantEvent(this.props._location.analytics_id, {
        event: eventName
      });
    }
  }

  isCachedOrderDataDiscardAble(orderData, locationExist) {
    if (!orderData) { return true; }
    else if (!orderData.selectedOutlet) { return true; }
    else if (
      !(
        this.props._location.is_outlet &&
        this.props._location.loc_id === orderData.selectedOutlet.loc_id
      )
    ) {
      return true;
    } else if (
      !OrderTypeHelper.checkIfOrderTypeAllowedForSelectedOutlet(
        this.props._location.orderTypes,
        orderData
      )
    ) {
      return true;
    }
    else if (
      !OrderTypeHelper.isDelivery(this.props._location.orderTypes, orderData.order_type_id)
    ) {
      return true;
    }
    else { return false; }
  }

  myOrderSidebar() {
    this.props.history.push(`${CONSTANTS.BASE_URL}${this.props._location.slug}/my-order`);
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    sidebarElement[0].style.right = '-100%';
  }

  closeSidebarNavigation() {
    this.closeNotification();
    this.closeSidebar();
  }

  closeSidebar() {
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    if (sidebarElement[0]) {
      sidebarElement[0].style.right = '-100%';
    }
  }

  openSidebar() {
    let sidebarElement = document.getElementsByClassName('sidebar-menu-data');
    sidebarElement[0].style.right = 0;
  }

  setCategoryListAndInputGroupStyle(categoryListDisplay, categorySearchGroupDisplay) {
    const categoryDataList = document.getElementsByClassName('category ');
    if (categoryDataList?.length > 1) {
      let categorySearch = document.getElementsByClassName('category-search-input-section');
      categorySearch[0].style.display = categorySearchGroupDisplay;
    }
  }

  setSearchbarWidth() {
    const searchBarInput = document.getElementsByClassName('searchbar-input-main');
    const customItem = document.getElementsByClassName('items-custom');
    if (customItem[0]?.clientWidth) {
      let width;
      if (window.innerWidth < 768) {
        width = window.innerWidth;
        searchBarInput[0].style.width = `${width}px`;
      } else {
        width = customItem[0].clientWidth;
        searchBarInput[0].style.width = `${width}px`;
      }
    }
  }

  openItemSearch() {
    const searchBarInput = document.getElementsByClassName('searchbar-input-main');

    this.setState({
      ...this.state,
      searchBarOpened: true,
      refreshItem: false
    });
    searchBarInput[0].style.display = 'flex';
    setTimeout(() => {
      searchBarInput[0].style.height = '50px';
      this.setSearchbarWidth();
      this.searchInputRef.current.focus();
    }, 100);
  }

  handleSearch(e) {
    this.setState({ searchText: e.target.value });
  }

  resetSearchText() {
    this.setState({ searchText: '' });
  }

  closeItemSearch() {
    this.setState({
      ...this.state,
      searchText: '',
      searchBarOpened: false,
      refreshItem: true
    });
    const searchBarInput = document.getElementsByClassName('searchbar-input-main');
    if (searchBarInput[0].style.height === '50px') {
      searchBarInput[0].style.height = '0';
      setTimeout(() => {
        searchBarInput[0].style.display = 'none';
      }, 200);
    }
  }

  showNotification() {
    let notification = document.getElementsByClassName('sidebar-menu-notification-data');
    notification[0].style.right = 0;
  }

  closeNotification() {
    let notification = document.getElementsByClassName('sidebar-menu-notification-data');
    notification[0].style.right = '-100%';
  }

  //   firebaseEvent(eventName, data = {}) {
  //       AnalyticsService.logEvent(eventName, {category: CONSTANTS.EVENTS.CONFIRM_ORDER.GROUP_NAME, ...data});
  // }

  resizePromotionalItems() {
    const promotionalItemsWidth = document.getElementsByClassName('promotional-items');
    let screenWidth = window.screen.width;
    let width = 0;
    if (screenWidth <= 768) {
      if (screenWidth <= 450) {
        width = promotionalItemsWidth[0]?.clientWidth * 0.5 - 14 - 20;
      } else {
        width = promotionalItemsWidth[0]?.clientWidth * 0.5 - 14;
      }
    } else {
      width = promotionalItemsWidth[0]?.clientWidth * 0.33 - 14;
    }

    let swiper = document.querySelector('.promotional-items > .swiper');
    swiper.style.width = '100%';
    // if (promotionalItemCard?.length > 0) {
    //     if (promotionalItemCard.length <= 2) {
    //         swiper.style.width = '100%';
    //     }
    //     let height = Number(width) / 2;
    //     for (let i = 0; i < promotionalItemCard.length; i++) {
    //         promotionalItemCard[i].style.width = `${width}px`;
    //         promotionalItemCard[i].style.height = `${height}px`;
    //     }
    // }
  }

  resizeWindow = debounce(() => {
    this.resizeTopMenuText();
    this.setSearchbarWidth();
    // this.resizePromotionalItems();
  }, 200);

  resizeTopMenuText() {
    const currentWidth = window.screen.width;
    this.setState({
      ...this.state,
      widthSize: currentWidth
    });
  }

  closeSearchInputBox() {
    this.setState({ searchText: '' });
    const searchBarInput = document.getElementsByClassName('searchbar-input-main');
    if (searchBarInput[0].style.height === '50px') {
      searchBarInput[0].style.height = '0';
      setTimeout(() => {
        searchBarInput[0].style.display = 'none';
      }, 200);
    }
  }

  checkIfClickedOutside(e) {
    if (
      this.searchInputBoxRef.current &&
      this.searchInputBoxRef.current.contains(e.target) === false
    ) {
      if (
        this.searchInputParentRef.current &&
        this.searchInputParentRef.current.contains(e.target) === false
      ) {
        if (e.target.classList.length > 0) {
          if (
            e.target.classList.contains('order-status-block') === true ||
            e.target.classList.contains('view-cart') === true ||
            e.target.classList.contains('clickable-checkout-section') === true
          ) {
          } else {
            // this.closeSearchInputBox();
          }
        } else {
          // this.closeSearchInputBox();
        }
      }
    }
  }

  async componentDidMount() {
    this.initializeLocalStorage();
    this.checkNetworkConnection();
    await this.fetchInitialData();
    await this.handleLocationData();
    this.setupEventListeners();
    this.checkGeolocationPermission();
    this.setState({ isLoaded: true, isLoggedIn: LoginService.isLoggedIn() });
  }

  initializeLocalStorage() {
    if (!this.props._location) {
      localStorage.setItem('is_custom_time', 0);
      localStorage.setItem('is_asap', 0);
    }
    localStorage.setItem('grid_layout', 'default');
    localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_analytics`, 0);
  }

  checkNetworkConnection() {
    if (!window.navigator.onLine) {
      ViewHelper.showNetworkAlert(ParamHelper.getLocationId(this.props));
    }
  }

  async fetchInitialData() {
    const locationId = ParamHelper.getLocationId(this.props);

    const dataFetchPromises = [
      this.props.getLocation(locationId, this.props.history),
      this.props.getOutlets({ loc_id: locationId }),
      this.props.getLocationLayoutSettings(locationId),
      LoginService.validateLogin()
    ];

    QRCodeService.setQrCode(window.location.href);

    const startTime = Date.now();
    await Promise.all(dataFetchPromises);
    const endTime = Date.now();
    console.log(`Menu componentDidMount took ${(endTime - startTime) / 1000} seconds`);

    this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.PAGE_LOAD);
  }

  async handleLocationData() {
    if (!this.props._location) return;

    this.generateToken();
    await this.processOrderTypes();
    this.props.getPaymentProcessor(this.props._location.loc_id);
    this.clearOutdatedOrder();
  }

  async processOrderTypes() {
    const ots = this.props._location.orderTypes.filter(ot => ot.active);
    if (!this.props._location.is_outlet && ots.length === 0) {
      await this.setState({ isOrderingEnabled: false });
    } else if (this.props._location.is_outlet && ots.length === 0) {
      await this.setState({ isOrderingEnabled: false });
      this.props.outlets.length > 1 ? this.toggleRouteModal() : this.updateMenu(false, true);
    } else {
      if (this.props.outlets.length === 1) {
        this.props.setLocation(this.props.outlets[0]);
      }
      await this.handleOrderDataWithTypes();
    }
  }

  async handleOrderDataWithTypes() {
    const locations = await UserLocationService.getSavedLocations();
    let orderData = CartService.getOrderData(this.props._location.orderTypes, this.props._location);
    const locationExist = orderData ? await UserLocationService.checkIfSavedLocationExist(orderData.selectedLocation) : false;

    if (this.isCachedOrderDataDiscardAble(orderData, locationExist) && this.props._location.location_status) {
      const orderDataInitial = CartService.getInitialStateFor(
        this.props._location,
        this.props.outlets,
        locations,
        this.state.geoLocation,
        orderData
      );
      if (orderDataInitial) {
        CartService.setOrderData(orderDataInitial, this.props._location.orderTypes, this.props._location);
      }
      if (orderDataInitial && locationExist) {
        orderDataInitial.selectedLocation = orderData.selectedLocation;
        CartService.setOrderData(orderDataInitial, this.props._location.orderTypes, this.props._location);
      }
      orderData = orderDataInitial;
    } else if (!locationExist) {
      orderData.selectedLocation = locations.length > 0 ? locations[0] : null;
    }

    if (orderData && this.props._location.location_status) {
      orderData = await TimeHelper.setOrderTimeToLatestPossible(orderData, this.props._location);
      orderData.selectedOutlet = this.props._location;
      CartService.setOrderData(orderData, this.props._location.orderTypes, this.props._location);
      this.updateMenu(!this.props._location.is_master_venue, true);
    } else {
      ViewHelper.showAlert({
        title: 'Sorry',
        text: 'We are not taking orders currently. Please be sure to come back another time.'
      });
      orderData = await TimeHelper.setOrderTimeToLatestPossible(orderData, this.props._location);
      orderData.selectedOutlet = this.props._location;
      CartService.setOrderData(orderData, this.props._location.orderTypes, this.props._location);
      this.updateMenu(false, true);
    }

    if (this.props.outlets && this.props.outlets.length === 1) {
      this.updateMenu(false, true);
    }
  }

  clearOutdatedOrder() {
    CartService.clearOrderData(this.props._location);
    const createdOrder = CartService.getCreatedOrder();
    if (createdOrder && createdOrder.location_id !== this.props._location?.loc_id) {
      CartService.setCreatedOrder('');
    }
  }

  setupEventListeners() {
    document.addEventListener('category-changed', this.categoryChangeEvent.bind(this));
    window.addEventListener('resize', this.resizeWindow);
    document.addEventListener('mousedown', this.checkIfClickedOutside.bind(this));
    window.addEventListener('beforeunload', this.checkBeforeUnload.bind(this));
  }

  checkGeolocationPermission() {
    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' }).then(result => {
        if (result.state === 'granted') {
          this.setState({ active: true, isLocationEnable: true });
          navigator.geolocation.getCurrentPosition(
            this.onGeoLocationSuccess.bind(this),
            this.onGeoLocationError.bind(this),
            {
              enableHighAccuracy: true,
              timeout: CONSTANTS.SETTINGS.LOCATION_TIMEOUT
            }
          );
        } else if (result.state === 'prompt') {
          this.setState({ isLocationEnable: true });
        }
        // Handle 'denied' state if necessary
      });
    }
  }


  checkBeforeUnload() {
    if (this.props._location) {
      const orderData = CartService.getOrderData(
        this.props._location.orderTypes,
        this.props._location
      );
      orderData.order_date = CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY;
      CartService.setOrderData(orderData, this.props._location.orderTypes, this.props._location);
      cookies.remove('sav_aff_info');
      cookies.remove('_suj_time');
    }
  }
  async generateToken() {
    let token = FirebaseNotificationService.getTokenFromCache();
    let mobile_fcm = localStorage.getItem('mobile_fcm_token');
    if (mobile_fcm) {
      await this.saveToken(mobile_fcm, token);
    } else {
      if (!token) {
        token = await FirebaseNotificationService.getToken();
        if (token) await FirebaseNotificationService.setTokenInCache(token);

      } else {
        await FirebaseNotificationService.setTokenInCache(token);
      }
      await this.saveToken(mobile_fcm, token)
    }
  }

  async saveToken(mobile_fcm, web_fcm) {
    if (this.props._location && (mobile_fcm || web_fcm)) {
      let location = this.props._location;
      const loc_id = location.is_outlet ? location.parent_id : location.loc_id;
      await FirebaseNotificationService.saveToken(mobile_fcm, web_fcm, loc_id);
    }
  }

  componentWillUnmount() {
    // clearTimeout(this.timeoutId);
    UserLocationService.setCheckForLocation(true);
    document.removeEventListener('category-changed', this.categoryChangeEvent.bind(this));
    window.removeEventListener('resize', this.resizeWindow);
    document.removeEventListener('mousedown', this.checkIfClickedOutside.bind(this));
    // window.removeEventListener('beforeunload', this.checkBeforeUnload.bind(this));
  }

  async componentDidUpdate(prevProps) {
    ViewHelper.setCanonical(window.location.href);
    if (this.state.isLoaded) {
      const locationId = ParamHelper.getLocationId(this.props);
      if (this.props._location) {
        if (this.props._location.is_master_venue) {
          if (this.state.isMasterOpen === false) {
            await this.setState({ isLoaded: false });
            const orderData = CartService.getOrderData(
              this.props._location.orderTypes,
              this.props._location
            );
            const parts =
              this.props.history.location.pathname.indexOf('/item/') > -1
                ? this.props.history.location.pathname.split('/')
                : [];
            const pathname =
              parts.length > 0
                ? `/${orderData.selectedOutlet.slug}/${parts[2]}/${parts[3]}`
                : `/${orderData.selectedOutlet.slug}`;
            await this.props.getLocation(locationId, this.props.history);
            this.props.history.replace({ pathname });
            this.setState({ isLoaded: true });
          }
        } else if (this.props._location.loc_id !== prevProps._location?.loc_id) {
          this.updateMenu(true);
        }
      }
    }
    if (prevProps._location) {
      if (prevProps._location.loc_id !== this.props._location.loc_id) {
        this.setState({ banner_image_list: [], banner_details: [], mobile_banner_image_list: [] });
        if (this.videoRef && this.videoRef.current) {
          this.videoRef.current.play();
        }
      }
    }
  }

  async toggleModal() {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  async toggleBinModal() {
    if (this.state.showBinModal) {
      if (this.props.history.length > 2) {
        this.props.history.replace(`${CONSTANTS.BASE_URL}${this.props._location.slug}`);
      }
    }
    this.setState({
      showBinModal: !this.state.showBinModal
    });
  }

  togglePrefModal() {
    this.setState({ showOrderPref: !this.state.showOrderPref });
  }

  toggleOrderPrefMobileModal() {
    this.setState({
      showOrderPrefMobile: !this.state.showOrderPrefMobile
    });
  }
  async toggleRouteModal() {
    await this.setState({
      showRouteModal: !this.state.showRouteModal
    });
  }

  async closeRouteModal() {
    this.updateMenu(false, true);
  }

  async addOptions(item) {
    await this.setState({ item_id: item, selectedItem: item })
    this.toggleModal();
  }

  addToCart(item) {
    if (!this.state.isOrderingEnabled) {
      return;
    }
    const selectedOutlet = this.state.orderData?.selectedOutlet;
    if (!selectedOutlet) {
      this.togglePrefModal();
      return;
    }

    const options = item.MenuOptions;
    if (options && options.length > 0) return this.addOptions(item);
    if (this.props.toast === 1) {
      this.props.getToastSettings(2);
      setTimeout(this.props.getToastSettings.bind(this, 3), 3000);
    }
    item.loc_id = selectedOutlet.loc_id;
    CartService.addItem(item);
    this.props.updateCart();
  }

  removeFromCart(item) {
    CartService.removeItem(item);
    this.props.updateCart();
  }

  renderPromotionTitles(titles) {
    return titles.map((tit) => (
      <div className="info ps-3 pe-3 my-1">
        <a href='#/' className="f4 text-muted text-decoration-none text-normal font-color-white h2-color-bg border-radius-50 p-1">
          <FontAwesomeIcon
            color="white"
            icon={faTag}
            className="fa-flip-horizontal h2-color-text"
          />
          <span className="ps-2 h2-color-text">{tit}</span>
        </a>
      </div>
    ));
  }

  goToCart() {
    this.props.history.push(
      `${CONSTANTS.BASE_URL}${ParamHelper.getLocationId(this.props)}/confirm/`
    );
  }

  async updateMenu(isCompUpdate = false, isOutletRouting = false, isClearItems = false) {
    const { _location, outlets, history, clearItems, getLocation, getAllItems, getCategories, setLocation } = this.props;
    const { showOrderPrefMobile, showOrderPref, showRouteModal } = this.state;
    if (!isOutletRouting) {
      if (_location.is_master_venue && !showRouteModal && outlets.length > 0 && !history.location.pathname.includes('/item/')) {
        await this.toggleRouteModal();
      }

      if (history.location.pathname.split('/')[2] === 'bindiscounts') {
        await this.toggleBinModal();
      }
    }

    if (isOutletRouting) {
      let orderData = CartService.getOrderData(_location.orderTypes, _location);
      if (!orderData) return;

      orderData = JSON.parse(JSON.stringify(orderData));

      if (isClearItems && _location.is_homecheff) {
        clearItems();
        await getLocation(_location.slug, history, new Date(orderData.order_time));

        if (!this.props.items) await getAllItems(_location, history);
        if (!this.props.categories) await getCategories(_location.menu_blob, _location.loc_id, history);
      }

      if (_location.is_outlet && !orderData.selectedOutlet) {
        orderData.selectedOutlet = _location;
      }

      if (showOrderPrefMobile && !isCompUpdate) {
        await this.toggleOrderPrefMobileModal();
      }

      const selectedOutlet = orderData.selectedOutlet;
      const oti = selectedOutlet?.orderTypes.find(ot => ot.order_type === orderData.order_type);
      const ots = selectedOutlet.orderTypes.filter(ot => ot.active);

      orderData.order_type_id = oti?.id || ots[0].id;
      orderData = await TimeHelper.setOrderTimeToLatestPossible(orderData, selectedOutlet);

      CartService.setOrderData(orderData, selectedOutlet?.orderTypes, selectedOutlet);

      const isOrderingEnabled = ots.length > 0;
      this.setState(
        { orderData, banner_image_list: [], banner_details: [], isOrderingEnabled },
        async () => {
          if (showOrderPref && !isCompUpdate) {
            await this.togglePrefModal();
          }
          if (_location.is_outlet || !_location.is_master_venue) {
            this.setPromotions();
          }

          let urlString = window.location.search || '';
          const parts = history.location.pathname.includes('/item/') ? history.location.pathname.split('/') : [];
          let pathname = parts.length > 0 ? `/${orderData.selectedOutlet.slug}/${parts[2]}/${parts[3]}` : `/${orderData.selectedOutlet.slug}${urlString}`;

          if (orderData.selectedOutlet?.slug !== history.location.pathname.split('/')[1]) {
            if (showRouteModal) {
              await this.toggleRouteModal();
            }
            ViewHelper.setDocumentTitle(orderData.selectedOutlet.meta.title);

            if (history.location.pathname.includes('/item/')) {
              pathname = `/${orderData.selectedOutlet.slug}${urlString}`;
            }

            history.replace({ pathname });
            setLocation(orderData.selectedOutlet);
          }

          setTimeout(() => {
            if (history.location.pathname.includes('/category/')) {
              const category_id = window.location.search ? window.location.search.replace(/^\D+/g, '') : history.location.pathname.replace(/^\D+/g, '');
              const element = document.getElementById(`data-category-${category_id}`);
              if (element) {
                window.scrollTo({
                  left: 0,
                  top: element.offsetTop - 63,
                  behavior: 'smooth'
                });
              }
            }
          }, 1000);
        }
      );
    }
  }


  getCartLoc(orderData, _location) {
    if (orderData && orderData.selectedOutlet) {
      const { selectedOutlet } = orderData;
      if (
        (_location.is_outlet && selectedOutlet.parent_id === _location.parent_id) ||
        (!_location.is_outlet && selectedOutlet.parent_id === _location.loc_id)
      ) {
        return selectedOutlet;
      }
    }
    return _location;
  }

  toggleLoginModal() {
    this.setState({ showLoginModal: !this.state.showLoginModal });
    this.closeSidebar();
  }

  toggleAccModal() {
    this.setState({ showAccModal: !this.state.showAccModal });
    this.closeSidebar();
  }
  setPromotions() {
    let promises = [];
    promises.push(this.props.getPromotions(this.props._location.slug));
    promises.push(this.props.getLoyalties(this.props._location.slug));
    promises.push(this.props.getBinDiscounts(this.props._location.slug, this.props.history));
    Promise.all(promises);
  }

  async onLoginCallback(status) {
    if (status) {
      this.setPromotions();
      const locations = await UserLocationService.getSavedLocations();
      if (locations && locations.length > 0) {
        const orderData = CartService.getOrderData(
          this.props._location.orderTypes,
          this.props._location
        );
        if (orderData.selectedOutlet) {
          orderData.selectedLocation = CartService.getMinDistanceLocation(
            locations,
            `${orderData.selectedOutlet.latitude},${orderData.selectedOutlet.longitude}`
          );
        } else if (this.state.geoLocation) {
          orderData.selectedLocation = CartService.getMinDistanceLocation(
            locations,
            this.state.geoLocation
          );
        } else {
          orderData.selectedLocation = locations[0];
        }
        CartService.setOrderData(orderData, this.props._location.orderTypes, this.props._location);
      }
    }
    this.setState({ isLoggedIn: status }, this.toggleLoginModal.bind(this));
  }

  async updateLoginStatus(status) {
    await this.setState({ isLoggedIn: status });
  }

  beginCheckout() {
    this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.BEGIN_CHECKOUT);
  }

  getAllowedOrderTypes(outlets) {
    if (!outlets) return {};

    const allowedOrderTypes = {};
    for (let i = 0; i < outlets.length; i++) {
      const out = outlets[i];
      for (let j = 0; j < out.orderTypes.length; j++) {
        allowedOrderTypes[out.orderTypes[j].order_type] = true;
      }
    }
    return allowedOrderTypes;
  }

  getPromotionLength(promotionList) {
    let length = 0;
    if (promotionList !== undefined || promotionList !== null) {
      if (promotionList?.basket.length > 0) {
        length += promotionList?.basket.length;
      }
      if (promotionList?.all_items.length > 0) {
        length += promotionList?.all_items.length;
      }
      if (promotionList?.categories.length > 0) {
        length += promotionList?.categories.length;
      }
      if (promotionList?.items.length > 0) {
        length += promotionList?.items.length;
      }
    }
    return length;
  }

  goToCheckOut(cartLoc) {
    const connection = window.navigator.onLine;
    if (connection) {
      this.props.history.push(`/${cartLoc.slug}/confirm`)
    } else {
      ViewHelper.showNetworkAlert(cartLoc.name);
    }
  }

  goToBannerURL(url) {
    if (url.indexOf('/item/') > -1) {
      window.location.href = url;
    } else if (url.indexOf('/category/') > -1) {
      const parts = url.split('/')
      let pathname = `/${parts[3]}/${parts[4]}/${parts[5]}`
      this.props.history.replace(pathname);
      setTimeout(() => {
        if (this.props.history.location.pathname.indexOf('/category/') > -1) {
          let category_id = this.props.history.location.search ? this.props.history.location.search.replace(/^\D+/g, '') : this.props.history.location.pathname.replace(/^\D+/g, '');
          let element = document.getElementById(`data-category-` + category_id);
          window.scrollTo({
            left: 0,
            top: element.offsetTop - 63,
            behavior: 'smooth'
          });

        }
      }, 1000);
    } else {
      window.open(url, '_blank').focus();
    }

  }

  render() {
    const { _location, cart, promotionTitles, error, promotions, bindiscounts } = this.props;
    localStorage.setItem('grid_layout', _location?.layout);
    if (_location !== null) {
      this.state.banner_details.push({
        banner_link: _location.banner1_link,
        banner_txt: _location.banner1_txt
      })
      this.state.banner_details.push({
        banner_link: _location.banner2_link,
        banner_txt: _location.banner2_txt
      })
      this.state.banner_details.push({
        banner_link: _location.banner3_link,
        banner_txt: _location.banner3_txt
      })
      this.state.banner_details.push({
        banner_link: _location.banner4_link,
        banner_txt: _location.banner4_txt
      })
      if (_location?.img !== null && _location?.img !== '') {
        let imgUrl = `${ImageHelper.getImageURL(`${_location.img}`, '?func=crop&w=1200&h=500')}`;
        if (this.state.banner_image_list.includes(imgUrl) === false) {
          this.state.banner_image_list.push(imgUrl);
        }
      }
      if (_location?.img1 !== null && _location?.img1 !== '') {
        let imgUrl = `${ImageHelper.getImageURL(`${_location.img1}`, '?func=crop&w=1200&h=500')}`;
        if (this.state.banner_image_list.includes(imgUrl) === false) {
          this.state.banner_image_list.push(imgUrl);
        }
      }
      if (_location?.img2 !== null && _location?.img2 !== '') {
        let imgUrl = `${ImageHelper.getImageURL(`${_location.img2}`, '?func=crop&w=1200&h=500')}`;
        if (this.state.banner_image_list.includes(imgUrl) === false) {
          this.state.banner_image_list.push(imgUrl);
        }
      }
      if (_location?.img3 !== null && _location?.img3 !== '') {
        let imgUrl = `${ImageHelper.getImageURL(`${_location.img3}`, '?func=crop&w=1200&h=500')}`;
        if (this.state.banner_image_list.includes(imgUrl) === false) {
          this.state.banner_image_list.push(imgUrl);
        }
      }
      if (_location.is_optimise_mv === 1 && _location.is_mv_autopick === 1) {

        if (_location?.img !== null && _location?.img !== '') {
          let imgUrl = `${ImageHelper.getImageURL(`${_location.img}`, '?func=crop&w=500&h=500')}`;
          if (this.state.mobile_banner_image_list.includes(imgUrl) === false) {
            this.state.mobile_banner_image_list.push(imgUrl);
          }
        }
        if (_location?.img1 !== null && _location?.img1 !== '') {
          let imgUrl = `${ImageHelper.getImageURL(`${_location.img1}`, '?func=crop&w=500&h=500')}`;
          if (this.state.mobile_banner_image_list.includes(imgUrl) === false) {
            this.state.mobile_banner_image_list.push(imgUrl);
          }
        }
        if (_location?.img2 !== null && _location?.img2 !== '') {
          let imgUrl = `${ImageHelper.getImageURL(`${_location.img2}`, '?func=crop&w=500&h=500')}`;
          if (this.state.mobile_banner_image_list.includes(imgUrl) === false) {
            this.state.mobile_banner_image_list.push(imgUrl);
          }
        }
        if (_location?.img3 !== null && _location?.img3 !== '') {
          let imgUrl = `${ImageHelper.getImageURL(`${_location.img3}`, '?func=crop&w=500&h=500')}`;
          if (this.state.mobile_banner_image_list.includes(imgUrl) === false) {
            this.state.mobile_banner_image_list.push(imgUrl);
          }
        }
      } else {
        if (_location?.mobileimg !== null && _location?.mobileimg !== '') {
          let imgUrl = `${ImageHelper.getImageURL(`${_location.mobileimg}`, '?func=crop&w=500&h=500')}`;
          if (this.state.mobile_banner_image_list.includes(imgUrl) === false) {
            this.state.mobile_banner_image_list.push(imgUrl);
          }
        }
        if (_location?.mobileimg1 !== null && _location?.mobileimg1 !== '') {
          let imgUrl = `${ImageHelper.getImageURL(`${_location.mobileimg1}`, '?func=crop&w=500&h=500')}`;
          if (this.state.mobile_banner_image_list.includes(imgUrl) === false) {
            this.state.mobile_banner_image_list.push(imgUrl);
          }
        }
        if (_location?.mobileimg2 !== null && _location?.mobileimg2 !== '') {
          let imgUrl = `${ImageHelper.getImageURL(`${_location.mobileimg2}`, '?func=crop&w=500&h=500')}`;
          if (this.state.mobile_banner_image_list.includes(imgUrl) === false) {
            this.state.mobile_banner_image_list.push(imgUrl);
          }
        }
        if (_location?.mobileimg3 !== null && _location?.mobileimg3 !== '') {
          let imgUrl = `${ImageHelper.getImageURL(`${_location.mobileimg3}`, '?func=crop&w=500&h=500')}`;
          if (this.state.mobile_banner_image_list.includes(imgUrl) === false) {
            this.state.mobile_banner_image_list.push(imgUrl);
          }
        }
      }
    }

    let icon,
      text = null;
    // if (isMobile && _location?.location_status) {
    //   if (this.props.toast === 1) {
    //     icon = swipeRightIcon;
    //     text = 'Swipe right to add an item';
    //   } else if (this.props.toast === 2) {
    //     icon = swipeLeftIcon;
    //     text = 'Swipe left to remove an item';
    //   }
    // }

    const allowedOrderTypes = this.getAllowedOrderTypes(this.props.outlets);
    const locationId = ParamHelper.getLocationId(this.props);
    let is_custom_time = localStorage.getItem('is_custom_time');
    let checkAsap = OrderTypeHelper.validateAdvAsapTimings(_location, this.state.orderData);
    const order_time = this.state.orderData
      ? this.state.orderData.isPickUpNow === 1
        ? 'ASAP'
        : _location?.is_adv_ordering === 1 ? checkAsap ? 'ASAP' : parseInt(is_custom_time) === 0 ? 'Select date & time' : moment(new Date(this.state.orderData.order_time)).format(
          CONSTANTS.DATE_TIMES.FORMAT.NEW_DISPLAY
        ) : 'Closed'
      : '-';
    const selected_outlet =
      this.state.orderData && this.state.orderData.selectedOutlet
        ? this.state.orderData.selectedOutlet.name
        : _location?.name;
    const order_type_id =
      this.state.orderData && this.state.orderData.order_type_id
        ? this.state.orderData.order_type_id
        : allowedOrderTypes['delivery']
          ? _location?.orderTypes.filter((ot) => ot.order_type === 'delivery')[0].id
          : _location?.orderTypes[0].id;
    if (error && error.code) return <ErrorHandler errorCode={error.code} errorMessage={error.message} locationSlug={locationId} />;
    if (_location && cart && this.state.orderData && _location.layout !== 'old') {
      const cartLoc = this.getCartLoc(this.state.orderData, _location);
      const orderTotal = CartService.getTotal(cartLoc.loc_id, cartLoc.tax_percent);
      let lineItems = CartService.getLineItems(cartLoc.loc_id);
      let rewardDiscount = 0;
      let reward = CartService.getLoyaltyDiscount();
      if (reward) {
        rewardDiscount = reward.discount / 100 * orderTotal;
      }
      let isRewardOrder = JSON.parse(localStorage.getItem('isRewardOrder'));
      const orderDiscount = CartService.getDiscount(cartLoc, promotions, order_type_id);
      let discount = orderDiscount.discount;
      if (orderDiscount.discount < rewardDiscount) {
        discount = rewardDiscount;
      }
      let afterDiscount = orderTotal
      const tax = CartService.getTaxWithTotal(afterDiscount, _location.tax_percent);
      afterDiscount = afterDiscount + tax - (discount);
      const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
      const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : 'card-outline-color-hide';

      if (_location.is_parent)
        return (
          <Redirect
            to={{
              pathname: `${CONSTANTS.BASE_URL}master/${_location.slug}`,
              state: { _location }
            }}
          />
        );
      return (
        <div>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          {this.state.showModal && (
            <ItemModal
              grid_layout={_location.layout}
              isOrderingEnabled={this.state.isOrderingEnabled}
              toggleModal={this.toggleModal.bind(this)}
              item={this.state.selectedItem}
              location={cartLoc}
              showModal={this.state.showModal}
              updateCart={this.props.updateCart}
              toast={this.props.toast}
              locationSettings={this.props.locationSettings}
              getToastSettings={this.props.getToastSettings}
            />
          )}
          {this.state.showBinModal && (
            <BinDiscountsModal
              bindiscounts={bindiscounts}
              _location={_location}
              toggleModal={this.toggleBinModal.bind(this)}
              showModal={this.state.showBinModal}
            />
          )}
          {this.state.isLoaded && (
            <CustomLogin
              _location={_location}
              isLogin={true}
              showModal={this.state.showLoginModal}
              toggleModal={this.toggleLoginModal.bind(this)}
              onLoginSuccess={this.onLoginCallback.bind(this, true)}
              onLoginFailed={this.onLoginCallback.bind(this, false)}
            />
          )}

          {this.state.isLoaded && (
            <RouteModal
              isLoggedIn={this.state.isLoggedIn}
              closeModal={this.closeRouteModal.bind(this)}
              toggleModal={this.toggleRouteModal.bind(this)}
              _outlets={this.props.outlets}
              location={_location}
              locationSettings={this.props.locationSettings}
              showModal={this.state.showRouteModal}
              geoLocation={this.state.geoLocation}
              updateMenu={this.updateMenu.bind(this)}
              settings={this.props.locationSettings}
            />
          )}
          {this.props.locationSettings.is_announcement === 1 && (
            <AnnouncementBar text={'Confirm Order'} _location={_location} locationSettings={this.props.locationSettings}
              isCenter={true} isBack={true} />
          )}
          {_location.layout === 'old' && (
            <Topheader text={'Confirm Order'} _location={_location} locationSettings={this.props.locationSettings}
              isCenter={true} isBack={true} />
          )}

          <div className="header-banner">
            <div className="header-top-section">
              {this.state.banner_image_list.length > 0 ? (
                <Banner
                  grid_layout={_location.layout}
                  isLoggedIn={this.state.isLoggedIn}
                  openSidebar={this.openSidebar.bind(this)}
                  isOrderingEnabled={this.state.isOrderingEnabled}
                  logoImg={ImageHelper.getImageURL(
                    this.props.locationSettings.logo,
                    '?func=cover&h=200&w=200&force_format=jpeg&q=100&optipress=3&sharp=1'
                  )}
                  outlets={this.props.outlets}
                  _location={_location}
                  toggleModal={this.toggleOrderPrefMobileModal.bind(this)}
                  toggleAccModal={this.toggleAccModal.bind(this)}
                  orderTypes={_location.orderTypes}
                  orderData={this.state.orderData}
                  isMenu={true}
                  banner_classname={'banner-top-section-with-bg-image'}
                  width={this.state.widthSize}
                  setLayout={this.changeLayout.bind(this)}
                  history={this.props.history}
                  main_location={true}
                  goBackUrl={`/${_location?.slug}`}
                  onLogin={this.updateLoginStatus.bind(this)}
                  updateMenu={this.updateMenu.bind(this)}
                  order_type_id={order_type_id}
                />
              ) : (
                <Banner
                  grid_layout={_location.layout}
                  isLoggedIn={this.state.isLoggedIn}
                  openSidebar={this.openSidebar.bind(this)}
                  isOrderingEnabled={this.state.isOrderingEnabled}
                  logoImg={ImageHelper.getImageURL(
                    this.props.locationSettings.logo,
                    '?func=cover&h=200&w=200&force_format=jpeg&q=100&optipress=3&sharp=1'
                  )}
                  outlets={this.props.outlets}
                  _location={_location}
                  toggleModal={this.toggleOrderPrefMobileModal.bind(this)}
                  toggleAccModal={this.toggleAccModal.bind(this)}
                  orderTypes={_location.orderTypes}
                  orderData={this.state.orderData}
                  isMenu={true}
                  banner_classname={_location.video_banner && _location.video_banner !== null ? 'banner-top-section-with-bg-image' : 'banner-top-section-without-bg-image'}
                  width={this.state.widthSize}
                  setLayout={this.changeLayout.bind(this)}
                  history={this.props.history}
                  main_location={true}
                  goBackUrl={`/${_location.slug}`}
                  onLogin={this.updateLoginStatus.bind(this)}
                  updateMenu={this.updateMenu.bind(this)}
                  order_type_id={order_type_id}
                />
              )}
            </div>
            {_location.video_banner !== '' && _location.video_banner !== null && (
              <video className='video-banner' autoPlay muted loop playsInline ref={this.videoRef}>
                <source src={ImageHelper.getVideoUrl(_location.video_banner)} />
              </video>
            )}
            {window.innerWidth > 768 && (_location.video_banner === '' || _location.video_banner === null) && this.state.banner_image_list.length > 0 && (
              <Swiper
                pagination={{
                  clickable: true
                }}
                modules={[Pagination, Autoplay]}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false
                }}
                slidesPerView={1}
              >
                {this.state.banner_image_list.map((url, index) => {
                  let banner_detail = this.state.banner_details[index];
                  return (
                    <SwiperSlide key={index} onClick={this.closeSidebarNavigation.bind(this)}>

                      {banner_detail ?
                        (banner_detail.banner_link === '' && banner_detail.banner_txt === '') || (banner_detail.banner_link === null && banner_detail.banner_txt === null) ?
                          <img src={url} alt="" />
                          : (banner_detail.banner_link !== '' && banner_detail.banner_txt === '') || (banner_detail.banner_link !== null && banner_detail.banner_txt === null) ?
                            <a onClick={() => this.goToBannerURL(this.state.banner_details[index].banner_link)}><img src={url} alt="" /></a> :
                            <div className='d-flex justify-content-center'>
                              <img src={url} alt={this.state.banner_details[index].banner_txt} />
                              <button
                                className="btn rounded-pill btn-slider"

                                onClick={() => this.goToBannerURL(this.state.banner_details[index].banner_link)}
                              >
                                {this.state.banner_details[index].banner_txt}
                              </button>
                            </div>
                        : ''
                      }

                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
            {window.innerWidth < 768 && (_location.video_banner === '' || _location.video_banner === null) && (

              _location.is_optimise_mv === 1 && _location.is_mv_autopick === 1 ?

                <Swiper
                  pagination={{
                    clickable: true
                  }}
                  modules={[Pagination, Autoplay]}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false
                  }}
                  slidesPerView={1}
                >
                  {this.state.banner_image_list.map((url, index) => {
                    let banner_detail = this.state.banner_details[index];

                    return (
                      <SwiperSlide className='swiper-slide-mobile' onClick={this.closeSidebarNavigation.bind(this)}>


                        {banner_detail ?
                          (banner_detail.banner_link === '' && banner_detail.banner_txt === '') || (banner_detail.banner_link === null && banner_detail.banner_txt === null) ?
                            <img src={url} alt="" />
                            : (banner_detail.banner_link !== '' && banner_detail.banner_txt === '') || (banner_detail.banner_link !== null && banner_detail.banner_txt === null) ?
                              <a onClick={() => this.goToBannerURL(this.state.banner_details[index].banner_link)}><img src={url} alt="" /></a> :
                              <div className='d-flex justify-content-center'>
                                <img src={url} alt={this.state.banner_details[index].banner_txt} />
                                <button
                                  className="btn rounded-pill btn-slider"

                                  onClick={() => this.goToBannerURL(this.state.banner_details[index].banner_link)}
                                >
                                  {this.state.banner_details[index].banner_txt}
                                </button>
                              </div>
                          : ''
                        }


                      </SwiperSlide>
                    );
                  })}
                </Swiper>

                :

                this.state.mobile_banner_image_list.length > 0 ?
                  <Swiper
                    pagination={{
                      clickable: true
                    }}
                    modules={[Pagination, Autoplay]}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false
                    }}
                    slidesPerView={1}
                  >
                    {this.state.mobile_banner_image_list.map((url, index) => {
                      let banner_detail = this.state.banner_details[index];
                      return (
                        <SwiperSlide className='swiper-slide-mobile' onClick={this.closeSidebarNavigation.bind(this)}>
                          {banner_detail ?
                            (banner_detail.banner_link === '' && banner_detail.banner_txt === '') || (banner_detail.banner_link === null && banner_detail.banner_txt === null) ?
                              <img src={url} alt="" />
                              : (banner_detail.banner_link !== '' && banner_detail.banner_txt === '') || (banner_detail.banner_link !== null && banner_detail.banner_txt === null) ?
                                <a onClick={() => this.goToBannerURL(this.state.banner_details[index].banner_link)}><img src={url} alt="" /></a> :
                                <div className='d-flex justify-content-center'>
                                  <img src={url} alt={this.state.banner_details[index].banner_txt} />
                                  <button
                                    className="btn rounded-pill btn-slider"

                                    onClick={() => this.goToBannerURL(this.state.banner_details[index].banner_link)}
                                  >
                                    {this.state.banner_details[index].banner_txt}
                                  </button>
                                </div>
                            : ''
                          }
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                  :
                  <Swiper
                    pagination={{
                      clickable: true
                    }}
                    modules={[Pagination, Autoplay]}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false
                    }}
                    slidesPerView={1}
                  >
                    {this.state.banner_image_list.map((url, index) => {
                      let banner_detail = this.state.banner_details[index];

                      return (
                        <SwiperSlide className='swiper-slide-mobile-defualt' onClick={this.closeSidebarNavigation.bind(this)}>
                          {banner_detail ?
                            (banner_detail.banner_link === '' && banner_detail.banner_txt === '') || (banner_detail.banner_link === null && banner_detail.banner_txt === null) ?
                              <img src={url} alt="" />
                              : (banner_detail.banner_link !== '' && banner_detail.banner_txt === '') || (banner_detail.banner_link !== null && banner_detail.banner_txt === null) ?
                                <a onClick={() => this.goToBannerURL(this.state.banner_details[index].banner_link)}><img src={url} alt="" /></a> :
                                <div className='d-flex justify-content-center'>
                                  <img src={url} alt={this.state.banner_details[index].banner_txt} />
                                  <button
                                    className="btn rounded-pill btn-slider"

                                    onClick={() => this.goToBannerURL(this.state.banner_details[index].banner_link)}
                                  >
                                    {this.state.banner_details[index].banner_txt}
                                  </button>
                                </div>
                            : ''
                          }
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
            )}
          </div>

          <OutletInformation
            windowWidth={this.state.widthSize}
            _location={_location}
            order_time={order_time}
            toggleModal={this.toggleOrderPrefMobileModal.bind(this)}
            classname={'mobile-outlet'}
            selected_outlet={selected_outlet}
            order_type_id={order_type_id}
            order_type_list={_location?.orderTypes}
          />

          {this.state.isLoaded && (
            <PrefModal
              isLoggedIn={this.state.isLoggedIn}
              toggleLoginModal={this.toggleLoginModal.bind(this)}
              toggleModal={this.toggleOrderPrefMobileModal.bind(this)}
              _outlets={this.props.outlets}
              location={_location}
              promotions={this.props.promotions}
              locationSettings={this.props.locationSettings}
              showModal={this.state.showOrderPrefMobile}
              geoLocation={this.state.geoLocation}
              updateMenu={this.updateMenu.bind(this)}
            />
          )}

          {this.state.isLoaded && (
            <AccDeletion
              showModal={this.state.showAccModal}
              toggleModal={this.toggleAccModal.bind(this)}
            />
          )}
          {this.props.locationSettings.is_header === 1 && (
            <div className="container-fluid header-img restaurant-settings header-bg">
              {this.props.locationSettings.header_design_enable === 1 ? window.innerWidth < 768 ? <LazyLoadImage
                src={this.props.locationSettings.header_img_mobile ? ImageHelper.getImageURL(`${this.props.locationSettings.header_img_mobile}`, '?func=crop&w=768&h=300') : restaurantSettingBg}
                alt='infobg'
              />
                :
                <LazyLoadImage
                  src={this.props.locationSettings.header_img ? ImageHelper.getImageURL(`${this.props.locationSettings.header_img}`, '?func=crop&w=1200&h=300') : restaurantSettingBg}
                  alt='infobg'
                />

                : ''
              }
              <div
                className={
                  this.state.banner_image_list.length > 0
                    ? 'row p-2 header-img top-desc justify-content-between'
                    : 'row p-2 header-img top-desc justify-content-between'
                }
              >
                <div className="col-md-12 order-lg-1 order-md-1 padding-zero">
                  <Intro
                    grid_layout={_location.layout}
                    _location={cartLoc}
                    goBack={this.props.onBackButtonPressed}
                  />
                  <Info
                    grid_layout={_location.layout}
                    _location={this.props._location}
                    settings={this.props.locationSettings}
                    outlets={this.props.outlets}
                    orderTypes={_location.orderTypes}
                    orderData={this.state.orderData}
                  />
                </div>
              </div>
            </div>
          )}
          <div className={`container-fluid primary-color ${this.props.locationSettings.is_header !== 1 ? 'mt-0' : 'mt-0'}`}>
            <div
              className="row row-bg category-section-row primary-color"
              style={{
                paddingTop: this.props.categories?.length <= 1 && '20px'
              }}
            >
              {this.props.categories?.length >= 1 && (
                <div className="category-section">
                  <div className="category-section-first primary-color">
                    <div
                      onClick={
                        this.state.searchBarOpened === false
                          ? this.openItemSearch.bind(this)
                          : this.closeItemSearch.bind(this)
                      }
                      className="category-section-first__searchbar"
                      ref={this.searchInputBoxRef}
                    >
                      <div className={`category-section-first__searchbar__icon custom-searchbar-icon card-color hovernowshodow ${card_outline}`}>
                        <FontAwesomeIcon icon={faSearch} size={'lg'} color='var(--highlight-color)' />
                      </div>
                    </div>
                    <Categories
                      selectedOutlet={this.state.orderData?.selectedOutlet}
                      searchText={this.state.searchText}
                    />

                    <div
                      ref={this.searchInputParentRef}
                      style={{
                        marginBottom: this.getPromotionLength(this.props.promotions) === 0 && '0'
                      }}
                      className={`searchbar searchbar-input-main search-bar-width ${this.state.searchbar_open_close_classname}`}
                    >
                      <div className="searchbar__icon" onClick={this.openItemSearch.bind(this)}>
                        <FontAwesomeIcon icon={faSearch} size={'lg'} />
                      </div>
                      <div className="searchbar__input-group category-search-input-section">
                        <input
                          ref={this.searchInputRef}
                          type="text"
                          placeholder={'Search Item'}
                          value={this.state.searchText}
                          onChange={this.handleSearch.bind(this)}
                        />
                        <div
                          className="searchbar__input-group__close-icon"
                          onClick={this.closeItemSearch.bind(this)}
                        >
                          <FontAwesomeIcon icon={faTimes} size={'lg'} />
                        </div>
                      </div>
                    </div>
                  </div>
                  {_location.is_ecommerce === 0 && (
                    <StyledStatusBlock className={'status-block-mobile'}>
                      <StatusBlock grid_layout={_location.layout} />
                    </StyledStatusBlock>
                  )}
                </div>
              )}
              <div
                className="col-lg-8 col-md-7 category-items-col px-0 pb-1"
                style={{ minHeight: window.innerHeight, overflow: 'hidden' }}
              >
                <PromotionalItems
                  category_length={this.props.categories?.length}
                  promotions={promotions}
                  currentWidth={this.state.widthSize}
                  _location={_location}
                />
                <BindiscountItems
                  category_length={this.props.categories?.length}
                  promotions={bindiscounts}
                  currentWidth={this.state.widthSize}
                  showModal={this.toggleBinModal.bind(this)}
                  _location={_location}
                />
                <PopularItems isOrderingEnabled={this.state.isOrderingEnabled} />

                <Items
                  layout={_location.layout}
                  searchText={this.state.searchText}
                  isOrderingEnabled={this.state.isOrderingEnabled}
                  _location={_location}
                  order_type_id={order_type_id}
                  selectedOutlet={this.state.orderData?.selectedOutlet}
                  addToCart={this.addToCart.bind(this)}
                  removeFromCart={this.removeFromCart.bind(this)}
                  togglePrefModal={this.togglePrefModal.bind(this)}
                  toggleRouteModal={this.toggleRouteModal.bind(this)}
                />
              </div>
              <div className="col-lg-4 col-md-5 cart-list-col mt-2 d-none d-sm-none d-lg-block d-md-block mb-4">
                {_location.is_ecommerce === 0 && (
                  <StatusBlock grid_layout={_location.layout} />
                )}
                <div className={`card rounded p-3 cart-list card-color ${card_outline} hovernowshodow`}>
                  {lineItems.length > 0 && (
                    <React.Fragment>
                      <h2 className="my-order card-font-color">My Order</h2>
                      <div className={this.props.locationSettings.is_footer === 0 ? `menu-cart-list` : `menu-cart-list menu-cart-list-ecommerce`}>
                        <MenuCart grid_layout={_location.layout} _location={cartLoc} />
                        <div className="line-item-tax line-item-container-custom  p-3">
                          <div className="line-item">
                            <div className="f2 name card-font-color">Tax</div>
                            <div className="price text-right text-bold card-font-color">
                              {ViewHelper.toCurrency(
                                tax,
                                _location.currency,
                                _location.decimal_places
                              )}
                            </div>
                          </div>
                        </div>
                        {Number(orderTotal - (orderTotal - (discount))) > 0 && (
                          <div className="line-item-discount line-item-container-custom  p-3">
                            <div className="line-item">
                              <div className="f2 name card-font-color">Discount</div>
                              <div className="price text-right text-bold card-font-color">
                                {ViewHelper.toCurrency(
                                  Number(orderTotal - (orderTotal - (discount))),
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="cart-checkout-section">
                        <div className="cart-checkout-section__total">
                          <div className="f2 name card-font-color">Total</div>
                          <div className="price text-right text-bold card-font-color">
                            {orderTotal === afterDiscount ? (
                              ViewHelper.toCurrency(
                                afterDiscount,
                                _location.currency,
                                _location.decimal_places
                              )
                            ) : (
                              <>
                                <span>
                                  {ViewHelper.toCurrencyWithZero(
                                    afterDiscount,
                                    _location.currency,
                                    _location.decimal_places
                                  )}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                        <a className='clickable-checkout-section'>
                          <Button className={`col mr-1 clickable-checkout-section ${branding_btn}`} onClick={this.goToCheckOut.bind(this, cartLoc)}>
                            {' '}
                            Checkout
                          </Button>
                        </a>
                      </div>
                    </React.Fragment>
                  )}
                  {lineItems.length === 0 && (
                    <>
                      <div className="cart-checkout-disabled">
                        <a>
                          <button className={`col mr-1 faded highlight-color-bg ${this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn'} `} color="primary" onClick={this.goToCheckOut.bind(this, cartLoc)}>
                            Checkout
                          </button>
                        </a>
                        <div className="f3 p-3 text-center card-subtitle-color">Your basket is empty</div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div
              className="row"
              style={{
                width: '100%',
                position: 'fixed',
                bottom: 0,
                zIndex: 999999
              }}
            >
              <Toast icon={icon} text={text} />
            </div>

          </div>
          {this.props.locationSettings.is_footer === 1 ?
            <Footer location={_location} logo={logo} class='mt-1' /> :
            <div className="margin-div-bg primary-color d-flex justify-content-center ">
              <p className="mb-0 mt-4 primary-font-color"><a target="_blank" href="https://plugd.tech" className="ps-1 primary-font-color"><img className='pb-1' src={logo} width='20' height='23' ></img></a>&nbsp;&nbsp;<b>Powered by <a target="_blank" href="https://plugd.tech" className="ps-1 primary-font-color">Plugd</a></b></p>
            </div>
          }
          <div className="d-lg-none d-md-none d-sm-block">
            <ViewCart
              text={'Checkout'}
              _location={cartLoc}
              view="MENU"
              locationSettings={this.props.locationSettings}
              promotions={promotions}
              orderTypes={_location.orderTypes}
              order_type_id={order_type_id}
              orderData={this.state.orderData}
            />
          </div>
        </div >
      );
    } else if (_location && cart && _location.layout === 'old') {
      const cartLoc = this.getCartLoc(this.state.orderData, _location);
      let lineItems = CartService.getLineItems(cartLoc.loc_id);
      const orderTotal = CartService.getOrderTotal(cartLoc.loc_id, cartLoc.tax_percent);
      let rewardDiscount = 0;
      let reward = CartService.getLoyaltyDiscount();
      if (reward) {
        rewardDiscount = reward.discount / 100 * orderTotal;
      }
      let isRewardOrder = JSON.parse(localStorage.getItem('isRewardOrder'));
      const orderDiscount = CartService.getDiscount(cartLoc, promotions, order_type_id);
      let discount = orderDiscount.discount;
      if (orderDiscount.discount < rewardDiscount) {
        discount = rewardDiscount;
      }
      const afterDiscount = orderTotal - discount;
      const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
      const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : 'card-outline-color-hide';
      if (_location.is_parent)
        return (
          <Redirect
            to={{
              pathname: `${CONSTANTS.BASE_URL}master/${_location.slug}`,
              state: { _location }
            }}
          />
        );
      return (
        <StyledOldHeaderImg>
          {this.state.showModal && (
            <ItemModal
              isOrderingEnabled={this.state.isOrderingEnabled}
              toggleModal={this.toggleModal.bind(this)}
              item={this.state.selectedItem}
              location={cartLoc}
              locationSettings={this.props.locationSettings}
              showModal={this.state.showModal}
              updateCart={this.props.updateCart}
              toast={this.props.toast}
              getToastSettings={this.props.getToastSettings}
            />
          )}
          {this.state.isLoaded && (
            <PrefModal
              isLoggedIn={this.state.isLoggedIn}
              toggleLoginModal={this.toggleLoginModal.bind(this)}
              toggleModal={this.togglePrefModal.bind(this)}
              _outlets={this.props.outlets}
              location={_location}
              promotions={this.props.promotions}
              locationSettings={this.props.locationSettings}
              showModal={this.state.showOrderPref}
              geoLocation={this.state.geoLocation}
              updateMenu={this.updateMenu.bind(this)}
            />
          )}
          {this.state.isLoaded && (
            <AccDeletion
              showModal={this.state.showAccModal}
              toggleModal={this.toggleAccModal.bind(this)}
            />
          )}
          {this.state.isLoaded && (
            <RouteModal
              isLoggedIn={this.state.isLoggedIn}
              closeModal={this.closeRouteModal.bind(this)}
              toggleModal={this.toggleRouteModal.bind(this)}
              _outlets={this.props.outlets}
              location={_location}
              locationSettings={this.props.locationSettings}
              showModal={this.state.showRouteModal}
              geoLocation={this.state.geoLocation}
              updateMenu={this.updateMenu.bind(this)}
              settings={this.props.locationSettings}
            />
          )}
          {this.state.isLoaded && (
            <CustomLogin
              _location={_location}
              isLogin={true}
              showModal={this.state.showLoginModal}
              toggleModal={this.toggleLoginModal.bind(this)}
              onLoginSuccess={this.onLoginCallback.bind(this, true)}
              onLoginFailed={this.onLoginCallback.bind(this, false)}
            />
          )}
          <Topheader _location={_location} locationSettings={this.props.locationSettings}
          />
          <div className="container-fluid header-img header-bg">
            <div className="row p-0 m-0 pb-2 header-img top-desc justify-content-between">
              <div className="col-md-6 order-lg-2 order-md-2 padding-zero">
                <div
                  className="header-img center-aligned float-md-right"
                  style={{ float: 'right' }}
                >
                  <Banner
                    grid_layout={_location.layout}
                    isOrderingEnabled={this.state.isOrderingEnabled}
                    outlets={this.props.outlets}
                    _location={_location}
                    toggleModal={this.togglePrefModal.bind(this)}
                    orderTypes={_location.orderTypes}
                    orderData={this.state.orderData}
                  />
                </div>
              </div>
              <div className="col-md-6 order-lg-1 order-md-1 padding-zero">
                <Intro
                  grid_layout={_location.layout}
                  _location={cartLoc}
                  goBack={this.props.onBackButtonPressed}
                />
                <Info
                  grid_layout={_location.layout}
                  _location={this.props._location}
                  settings={this.props.locationSettings}
                />
                <OldPromotionalTitles>
                  {this.renderPromotionTitles(promotionTitles)}
                </OldPromotionalTitles>
              </div>
            </div>
          </div>
          <div className="test-container">
            <div className="container-fluid primary-color">
              <div className="row row-bg primary-color">
                <div className='sticky-top p-0'>
                  <Categories selectedOutlet={this.state.orderData?.selectedOutlet} />
                </div>
                <div className="col-lg-8 col-md-7 p-0">
                  {_location.is_ecommerce === 0 && (
                    <StatusBlock grid_layout={_location.layout} />
                  )}
                  <PopularItems isOrderingEnabled={this.state.isOrderingEnabled} />
                  <Items
                    layout={_location.layout}
                    isOrderingEnabled={this.state.isOrderingEnabled}
                    _location={_location}
                    order_type_id={order_type_id}
                    selectedOutlet={this.state.orderData?.selectedOutlet}
                    addToCart={this.addToCart.bind(this)}
                    removeFromCart={this.removeFromCart.bind(this)}
                    togglePrefModal={this.togglePrefModal.bind(this)}
                    toggleRouteModal={this.toggleRouteModal.bind(this)}
                  />
                </div>
                <div className="col-lg-4 col-md-5 mt-2 d-none d-sm-none d-lg-block d-md-block">
                  <div className={`card box-shadow rounded p-3 cart-list card-color sticky-top ${card_outline}`} style={{ top: '70px' }}>
                    {lineItems.length > 0 && (
                      <React.Fragment>
                        {/* <Link to={`/${cartLoc.slug}/confirm`}> */}
                        <Button className={`col mr-1 highlight-color-bg border-0 ${this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn'}`} onClick={this.goToCheckOut.bind(this)}>
                          {' '}
                          <FontAwesomeIcon
                            className="mr-3"
                            size={'sm'}
                            icon={faShoppingBasket}
                            color='var(--button-font-color)'
                          />{' '}
                          Go to checkout
                        </Button>
                        {/* </Link> */}
                        <StyledDiv className="menu-cart-list">
                          <MenuCart grid_layout={_location.layout} _location={cartLoc} />
                          <div className="line-item-container p-3 branding-border-bottom">
                            <div className="line-item">
                              <div className="f2 name card-font-color">Tax</div>
                              <div className="price text-right text-bold card-font-color">
                                {ViewHelper.toCurrency(
                                  CartService.getTax(_location.loc_id, _location.tax_percent),
                                  _location.currency,
                                  _location.decimal_places
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="line-item-container p-3">
                            <div className="line-item">
                              <div className="f2 name card-font-color">Total</div>
                              <div className="price text-right text-bold card-font-color">
                                {orderTotal === afterDiscount ? (
                                  ViewHelper.toCurrency(
                                    afterDiscount,
                                    _location.currency,
                                    _location.decimal_places
                                  )
                                ) : (
                                  <>
                                    <span className="text-decoration-line-through mr-2 form-control-sm font-weight-lighter">
                                      {ViewHelper.toCurrency(
                                        orderTotal,
                                        _location.currency,
                                        _location.decimal_places
                                      )}
                                    </span>
                                    <span>
                                      {ViewHelper.toCurrency(
                                        afterDiscount,
                                        _location.currency,
                                        _location.decimal_places
                                      )}
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </StyledDiv>
                      </React.Fragment>
                    )}
                    {lineItems.length === 0 && (
                      <>
                        <Button className={`col mr-1 faded highlight-color-bg ${this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn'}`} color="primary" onClick={this.goToCheckOut.bind(this)}>
                          <FontAwesomeIcon className="mr-3" size={'sm'} icon={faShoppingBasket} />{' '}
                          Go to checkout{' '}
                        </Button>
                        <div className="f3 p-3 text-center card-subtitle-color">your basket is empty</div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="row"
                style={{
                  width: '100%',
                  position: 'fixed',
                  bottom: 0,
                  zIndex: 999999
                }}
              >
                <Toast icon={icon} text={text} />
              </div>
              <div className="margin-div primary-color" />
            </div>
          </div>
          <div className='margin-div primary-color' />
          {this.props.locationSettings.is_footer === 1 ?
            <Footer location={_location} logo={logo} /> :
            <div className="margin-div-bg primary-color d-flex justify-content-center ">
              <p class="mb-0 mt-4 primary-font-color"><a target="_blank" href="https://plugd.tech" class="ps-1 primary-font-color"><img class='pb-1' src={logo} width='20' height='23' ></img></a>&nbsp;&nbsp;<b>Powered by <a target="_blank" href="https://plugd.tech" class="ps-1 primary-font-color">Plugd</a></b></p>
            </div>
          }
          <div className="d-lg-none d-md-none d-sm-block">
            <ViewCart
              text={'View Cart'}
              _location={cartLoc}
              view="MENU"
              locationSettings={this.props.locationSettings}
              promotions={promotions}
              orderTypes={_location.orderTypes}
              order_type_id={order_type_id}
              orderData={this.state.orderData}
            />
          </div>
        </StyledOldHeaderImg>
      );
    }
    return <Spinner size={40} />;
  }
}

const StyledDiv = styled.div`
  .text-right {
    text-align: right !important;
  }
  .font-weight-lighter {
    font-weight: 400;
  }
`;
const StyledStatusBlock = styled.div`
  display: none;
  max-height: 33px;
  @media (max-width: 767px) {
    display: block;
    .order-status-section {
      top: 63px !important;
      position: sticky;
      a {
        .order-status-block {
          border-radius: unset;
          padding: 8px 18px;
        }
      }
    }
  }
  @media (max-width: 426px) {
    .order-status-section {
      top: 70px !important;
    }
  }
`;
const OldPromotionalTitles = styled.div`
  @media (max-width: 991px) {
    position: absolute;
    max-width: 400px;
  }
  @media (max-width: 767px) {
    position: relative;
    max-width: unset;
  }
  .info {
    @media (max-width: 767px) {
      padding-left: 1rem;
    }
    a {
      span {
        margin-left: 5px;
      }
    }
  }
`;

const StyledOldHeaderImg = styled.div`
  .items {
    .container-fluid {
      @media (min-width: 769px) {
        padding-left: 15px;
      }
      @media (max-width: 767px) {
        padding-right: 0.75rem;
        padding-left: 0.75rem;
      }
    }
  }
  .order-lg-2 {
    .header-img {
      @media (max-width: 767px) {
        width: 100%;
      }
    }
    .react-parallax {
      @media (max-width: 768px) {
        height: 200px;
      }
    }
  }
  .order-lg-1 {
    .intro,
    .info-old {
      @media (max-width: 767px) {
        padding: 0 1rem 0 1rem;
      }
    }
  }
  .order-md-1 {
    backgroun-color: pink;
    .intro {
      padding: 0;
      @media (max-width: 767px) {
        padding: 1rem 1rem 0 1rem;
      }
    }
  }
`;

function mapStateToProps(state) {
  const {
    location,
    cart,
    promotions,
    bindiscounts,
    locationSettings,
    childLocations,
    toast,
    error,
    categories,
    notifications
  } = state;
  const promotionTitles =
    promotions && location ? ViewHelper.getPromotionTitles(promotions, location) : [];
  return {
    _location: location,
    cart,
    promotions,
    bindiscounts,
    locationSettings,
    promotionTitles,
    error,
    toast: toast?.toast,
    outlets: childLocations,
    categories,
    notifications
  };
}

export default connect(mapStateToProps, {
  getOutlets,
  getLocation,
  clearLocation,
  clearItems,
  updateCart,
  getPromotions,
  getLoyalties,
  getBinDiscounts,
  getLocationLayoutSettings,
  getPaymentProcessor,
  getCategories,
  getAllItems,
  getNotifications,
  setLocation,
  getToastSettings: alerts.getToastSettings
})(
  withBackButtonHandled(Menu, (props) => {
    if (props.location && props.location.state) {
      window.location.href = props.location.state.backUrl;
    }
  })
);
